import React, {useEffect} from 'react'
import { useInView } from 'react-intersection-observer';
import { useInViewOptions, navLinks } from '../../utils/constants';
import { removeSelectedNavItem, selectActiveItemOnNav } from '../../utils/functions';
import {MdArrowRight} from 'react-icons/md'

import './Products.scss'
import MinidukanImage from '../../assets/minidukan.svg'
import CoinbundleImage from '../../assets/coinbundle.png'
import ProductR from './ProductR';
import ProductL from './ProductL';

const Products = () => {

    const { ref, inView, entry } = useInView(useInViewOptions);

    var projectsLink = '';
    navLinks.map(item => {
        if (item.key==='projects') {
            projectsLink = item.path
            return;
        }
    })

    useEffect(() => { 
        if (inView)  {
            selectActiveItemOnNav('projects');
        } else removeSelectedNavItem('projects');
    }, [inView]);

    const productsData = [
        {
            image: MinidukanImage,
            heading: "Minidukan",
            description: "An eCommerce platform that enables users to seamlessly set up their own online store in less than a minute. We successfully managed the end-to-end development of the application. Focusing strongly on the user interface and user experience. ",
            buttonText: "Let's Talk",
            buttonRef: "#contact-us",
        },
        {
            image: CoinbundleImage,
            heading: "Coinbundle",
            description: "An investment product that simplifies and streamlines the process of investing in cryptocurrencies. With Coin Bundle, users can easily invest in bundles of different cryptocurrencies, instead of having to navigate the complexities of selecting individual coins.",
            buttonText: "Let's Talk",
            buttonRef: "#contact-us",
        }
    ]

  return (
    <section ref={ref}>
        <div className="container">
            <h1 className='section__heading'>Our Latest Product</h1>

            <ProductR image={productsData[0].image} heading={productsData[0].heading} description={productsData[0].description} buttonText={productsData[0].buttonText} buttonRef={productsData[0].buttonRef}/>
            <ProductL image={productsData[1].image} heading={productsData[1].heading} description={productsData[1].description} buttonText={productsData[1].buttonText} buttonRef={productsData[1].buttonRef}/>

            <div className='viewmore__projects'>
                <a className='btn service__btn' href={projectsLink}>View More Projects <span><MdArrowRight /></span></a>
            </div>
        </div>
    </section>
  )
}

export default Products